import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const MenuPage = lazy(() => import('../pages/menu/page'));
const OrderPage = lazy(() => import('../pages/order/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/menu',
    element: <MenuPage />,
  },
  {
    path: '/order',
    element: <OrderPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
